export default "__VITE_ASSET__TyeDwAe1__"